import { useTheme } from '@salecycle/ui-component-library';
import { Background as RFBackground, BackgroundProps as RFBackgroundProps } from 'reactflow';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BackgroundProps extends RFBackgroundProps {}

const spacing = 16;
const size = 4;

const StyledBackground = styled(RFBackground)`
  background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
`;

export const Background = (props: BackgroundProps) => {
  const theme = useTheme();
  return <StyledBackground gap={spacing} size={size} color={theme.vars.newColor.lightGS1} {...props} />;
};
